module.exports = __webpack_public_path__ + "3c5c32c811f69f42995bfab99ab37ba3.png";